import React from "react";

const Footer = () => {
  const options = [
    "अभिप्राय",
    "वेबसाइट धोरणे",
    "साइटमॅप",
    "मदत",
    "संपर्क करा",
    "वेब माहिती व्यवस्थापक",
    "अभ्यागत सारांश"
  ];

  return (
    <footer className="bg-gray-950 py-4">
      <div className="max-w-6xl mx-auto flex justify-center">
        <ul className="flex flex-wrap justify-center gap-6 text-white font-medium text-sm">
          {options.map((option, idx) => (
            <li key={idx}>
              <a
                href="#"
                className="hover:text-cyan-600 hover:underline transition"
              >
                {option}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
